<div class="app-page" style="margin-left: 5px;">
  <!--  <app-schedule-menu  [CurrentPeriod]="selectDateText()" (previousEvent)="previous($event)" (nextEvent)="next($event)" (loadedEvent)="loaded($event)" ></app-schedule-menu>
  -->
<!--   <span style="font-size: large; font-weight: bold;">SCHEDULE</span> -->
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <mat-toolbar-row>
      <!-- <a mat-button  [routerLink]="[{ outlets: { schedule: ['month'] } }]"  [queryParams]="{ selectedDate: selectedDate  }" >MONTH</a>
      <a mat-button  [routerLink]="[{ outlets: { schedule: ['week'] } }]"  [queryParams]="{ selectedDate: selectedDate  }">WEEK</a>
      <a mat-button  [routerLink]="[{ outlets: { schedule: ['coming'] } }]"  [queryParams]="{ selectedDate: selectedDate  }">COMING</a> -->
      <a mat-icon-button (click)="setMode('month-small')">
        <span class="material-symbols-outlined">
          calendar_month
        </span>
      </a>
      <!-- <a mat-icon-button (click)="setMode('month')">
      <span class="material-symbols-outlined">
        calendar_month
      </span>
    </a> -->
    <a mat-icon-button (click)="setMode('week')" >
      <span class="material-symbols-outlined">
        view_agenda
      </span>
    </a>
    <a mat-icon-button (click)="setMode('coming')" >
      <span class="material-symbols-outlined">
        event_upcoming
      </span>
    </a>
     <a mat-icon-button (click)="setToday()" >
      <span class="material-symbols-outlined">
        today
      </span>
    </a>
  </mat-toolbar-row>
  @if (this.selectedView != 'coming') {
    <mat-toolbar-row>
      <button mat-icon-button (click)="previous()"><mat-icon>keyboard_arrow_left</mat-icon></button>
      <div style="width:100%; text-align: center;">
        {{this.selectDateText()}}
      </div>
      <button mat-icon-button (click)="next()"><mat-icon>keyboard_arrow_right</mat-icon></button>
    </mat-toolbar-row>
  }


</mat-toolbar>

@if (this.isLoading) {
  <mat-progress-bar mode="query"></mat-progress-bar>
}

<router-outlet name="schedule"></router-outlet>

</div>